import {
  FETCH_START,
  FETCH_RESET,
  HIDE_MESSAGE,
  SHOW_MESSAGE,
  CHANGE_LOADING_STATE,
  CLEAR_IS_USER_CHECK
} from "src/constants/ActionTypes";

/**
 * fetchStart: Request API
 *
 * @param {*} urlData
 * @param {*} method
 * @param {*} value
 * @param {*} apiType
 * @param {*} getName
 * @returns
 */
export const fetchStart = (urlData, method, value, apiType, getName = '') => {
  return {
    type: FETCH_START,
    urlData,
    method,
    value,
    apiType,
    getName
  }
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  }
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  }
};

export const fetchReset = () => {
  return {
    type: FETCH_RESET
  }
};

export const changeLoadingState = (value) => {
  return {
    type: CHANGE_LOADING_STATE,
    payload: { loading: value }
  }
};

export const clearIsUserCheck = () => {
  return {
    type: CLEAR_IS_USER_CHECK
  }
}
